import { bootstrapIcons } from '@/ui/Icon/bootstrapIcons';

bootstrapIcons();
